export default __webpack_public_path__ + "static/14-ea9e0749002e7309fb95cb78a0c8721b.jpg";